import { createRouter, createWebHashHistory } from 'vue-router'
import Login from '../views/Login.vue'
import MainBox from '../views/MainBox.vue'
import RoutesConfig from './config'
import store from '../store/index';
import Home from '../views/UserPage/home.vue'
import msgbox from '../views/UserPage/msg/msgbox.vue'
import NotFound from '../views/notfound/NotFound.vue'

import Songlist from '../views/UserPage/songlist.vue'
import About from '../views/UserPage/About.vue'
import Works from '../views/UserPage/Works.vue'
import Points from '../views/UserPage/Points.vue'
import Captain from '../views/UserPage/Captain.vue'
import UserLogin from '../views/UserPage/userlogin.vue'
import ExchangeRecord from '../views/UserPage/ExchangeRecord.vue'
const routes = [
  {
    path: "/admin/login",
    name: "login",
    component: Login
  },
  {
    path: "/user/login",
    name: "UserLogin",
    component: UserLogin
  },
  {
    path: "/mainbox",
    name: "mainbox",
    component: MainBox,
  },
  //
  {
    path: "/index",
    name: "Home",
    component: Home
  },

  {
    path: "/",
    name: "Home",
    component: Home
  },

  {
    path: "/admin",
    redirect: "/admin/login"
  },
  //作品预览，投稿内容展示
  {
    path: "/works",
    name: "Works",
    component: Works
  },
  //积分兑换
  {
    path: "/points",
    name: "Points",
    component: Points
  },
  //礼物查看，舰长/提督/总督信息地址填写地址跳转
  {
    path: "/captain",
    name: "Captain",
    component: Captain
  },
  //歌单
  {
    path: "/songlist",
    name: "Songlist",
    component: Songlist
  },
  //关于，联系我们
  {
    path: "/about",
    name: "About",
    component: About
  },
  //兑换记录
  {
    path: "/exchange-records",
    name: "ExchangeRecord",
    component: ExchangeRecord
  },

  {
    path: "/msgbox/message/:pathMatch(.*)*",
    component: msgbox
  },
  {
    path: "/:pathMatch(.*)*",
    component: NotFound,
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 后台路由的准入判断：必须同时有登录 token 与管理员身份。
// 说明：真正的权限边界在服务端（所有 /adminapi/ 管理接口都校验管理员 token），
// 这里只负责「没登录就不要把后台骨架渲染出来」。
const isAdminArea = (path) => path === '/admin' || path.startsWith('/admin/')
const isAdminPage = (path) => isAdminArea(path) && path !== '/admin/login'
const canEnterAdmin = () => !!localStorage.getItem('token') && store.state.userInfo && store.state.userInfo.role === 'admin'

router.beforeEach((to, from, next) => {
  // 后台区域准入（原来这里判的是 to.name === "Login"，而登录路由名是小写 login，分支永远不成立）
  if (isAdminPage(to.path) && !canEnterAdmin()) {
    next({ path: '/admin/login' })
    return
  }

  if (to.name === "Login" || to.name === "UserLogin") {
    next();
    return;
  }

  if (!store.state.isGetterRouter) {
    ConfigRouter();
    next({ path: to.fullPath });
  } else {
    next();
  }
});

const ConfigRouter = () => {
  if (!router.hasRoute("mainbox")) {
    router.addRoute(
      {
        path: "/mainbox",
        name: "mainbox",
        component: MainBox,
        children: RoutesConfig
      },
    )
  }
  RoutesConfig.forEach(item => {
    checkPermission(item) && router.addRoute("mainbox", item)
  })
  //修改isGetterRouter为true
  store.commit("changeGetterRouter", true)
}

/**
 * 单个后台路由的准入判断。
 * role 在数据库里是 varchar，实际值是 'admin'，所以不能和数字比较（原来写的是 === 1，恒为 false）。
 */
const checkPermission = (item) => {
  if (item.requireAdmin) {
    return store.state.userInfo && store.state.userInfo.role === 'admin'
  }
  if (item.requireAdminIP) {
    return !!store.state.userInfo && !!store.state.userInfo.role
  }
  return true
}


export default router
